import {Therapy} from './Therapy';
import {ClinicalData} from './ClinicalData';
import {Note} from './Note';
import {Therapy2} from './Therapy2';

export class StatForm {
  weight: string;
  height: string;
  age: string;
  sex: string;
  dateOfDiagnosis: string;
  ageOfDiagnosis: string;
  familiarity: string;
  pathologyDuration: string;
  pathology: string;
  // solo per CD
  infiammatorioCD: ClinicalData[] | null;
  stenosanteCD: ClinicalData[] | null;
  penetranteCD: ClinicalData[] | null;
  malattiaPerianaleCD: ClinicalData[] | null;
  locatColonCD: ClinicalData[] | null;
  locatIleumCD: ClinicalData[] | null;
  locatUpperGI: ClinicalData[] | null;
  // per UC e IBD_U
  localizzazioneUC: ClinicalData[] | null;
  // per tutti
  storicheEIMS: ClinicalData[];
  attiveEIMS: ClinicalData[];
  interventi: string;
  numResezioni: string;
  stomia: ClinicalData[];
  // terapia
  therapy5ASAOS: Therapy2[];
  therapyGCSOS: Therapy2[];
  therapyTOPICA: Therapy2[];
  therapyIMM: Therapy2[];
  therapyBIO: Therapy2[];
  //
  notes: string[];
  // therapy: string;
  therapies: Therapy[];



  // tslint:disable-next-line:max-line-length
  constructor(weight: string, height: string, age: string, sex: string,
              dateOfDiagnosis: string, ageOfDiagnosis: string, familiarity: string,
              pathologyDuration: string, pathology: string, notes: string[], therapies: Therapy[],
              infiammatorioCD: ClinicalData[], stenosanteCD: ClinicalData[],
              penetranteCD: ClinicalData[], malattiaPerianaleCD: ClinicalData[], locatColonCD: ClinicalData[],
              locatIleumCD: ClinicalData[], locatUpperGI: ClinicalData[], localizzazioneUC: ClinicalData[],
              storicheEIMS: ClinicalData[], attiveEIMS: ClinicalData[], interventi: string, numResezioni: string,
              stomia: ClinicalData[], therapy5ASAOS: Therapy2[], therapyTOPICA: Therapy2[], therapyGCSOS: Therapy2[],
              therapyIMM: Therapy2[], therapyBIO: Therapy2[]) {
    this.weight = weight;
    this.height = height;
    this.age = age;
    this.sex = sex;
    this.dateOfDiagnosis = dateOfDiagnosis;
    this.ageOfDiagnosis = ageOfDiagnosis;
    this.familiarity = familiarity;
    this.pathologyDuration = pathologyDuration;
    this.pathology = pathology;
    //
    this.infiammatorioCD = infiammatorioCD;
    this.stenosanteCD = stenosanteCD;
    this.penetranteCD = penetranteCD;
    this.malattiaPerianaleCD = malattiaPerianaleCD;
    this.locatColonCD = locatColonCD;
    this.locatIleumCD = locatIleumCD;
    this.locatUpperGI = locatUpperGI;
    // solo UC e altro
    this.localizzazioneUC = localizzazioneUC;
    //
    this.storicheEIMS = storicheEIMS;
    this.attiveEIMS = attiveEIMS;
    this.interventi = interventi;
    this.numResezioni = numResezioni;
    this.stomia = stomia;
    // terapia
    this.therapy5ASAOS = therapy5ASAOS;
    this.therapyTOPICA = therapyTOPICA;
    this.therapyGCSOS = therapyGCSOS;
    this.therapyIMM = therapyIMM;
    this.therapyBIO = therapyBIO;
    //
    this.notes = notes;
    // this.therapy = therapy;
    this.therapies = therapies;
  }
}
